import React from "react";
import PropTypes from "proptypes";
import s from "./Card.module.css";
import { Link } from "react-router-dom";
import { serverPath } from "config/config";

const Card = ({
  hash,
  cover = "",
  created = "0000-00-00 00:00:00",
  title = "Very simple and long title",
  description = "Something about current article. It's exist for user for fast search",
}) => {
  const formattedDate = new Date(created).toLocaleDateString("ru-RU", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  return (
    <Link
      to={`/admin/articles/${hash}`}
      className={s.cardLink}
      state={{
        articleTitle: title,
        cover: cover,
        description: description,
      }}
    >
      <div className={s.card}>
        <div
          className={s.cover}
          style={{
            backgroundImage: cover
              ? `url(${serverPath}${cover}`
              : `url(${serverPath}/scripts/data/covers/cover.jpg`,
          }}
        />
        <div className={s.content}>
          <div className={s.date}>{formattedDate}</div>
          <h3 className={s.title}>{title}</h3>
          <p className={s.description}>{description}</p>
        </div>
      </div>
    </Link>
  );
};

// ... оставляем существующие propTypes и defaultProps
export default Card;

// Card.propTypes = {
//   cover: PropTypes.string,
//   created: function (props, propName) {
//     const value = props[propName];
//     const dateRegex = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;
//     if (!dateRegex.test(value)) {
//       return new Error(
//         `Неверный формат даты. Ожидается "ГГГГ-ММ-ДД ЧЧ:ММ:СС".`
//       );
//     }
//     const date = new Date(value);
//     if (isNaN(date.getTime())) {
//       return new Error(`Дата некорректна.`);
//     }
//   },
//   title: PropTypes.string,
//   description: PropTypes.string,
// };
